module.exports = __webpack_public_path__ + "static/media/innerLogo.810a3f96.png";